var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarCareers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.586,
    height: 13.666,
    viewBox: "0 0 13.586 13.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rocket-lunch",
    d: "M1.412,7.106a1.647,1.647,0,0,1-.165-1.544A4.533,4.533,0,0,1,3.432,3.435a6.256,6.256,0,0,1,2.2-.627q-.5.616-1,1.316A19.8,19.8,0,0,0,2.89,7.388l-.205.461A1.708,1.708,0,0,1,1.412,7.106ZM2.195,9.5a6.373,6.373,0,0,0-1.039,2.264.984.984,0,0,0,1.179,1.179A6.375,6.375,0,0,0,4.6,11.9h0a1.7,1.7,0,1,0-2.4-2.4Zm4.492,1.687-.464.206v.166a1.5,1.5,0,0,0,.444,1.061,1.443,1.443,0,0,0,1.005.409c1.334-.019,2.416-1.234,2.984-2.365a6.245,6.245,0,0,0,.629-2.238q-.623.509-1.335,1.019a19.718,19.718,0,0,1-3.264,1.741h0ZM14.714,1.052C14.638,3.516,12.864,5.96,9.29,8.524a19.812,19.812,0,0,1-3.067,1.626V9.831A1.991,1.991,0,0,0,4.242,7.85H3.924A19.842,19.842,0,0,1,5.552,4.783c2.558-3.566,5-5.342,7.457-5.423C14.235-.64,14.714-.141,14.714,1.052Zm-3.4,3.118A1.415,1.415,0,1,0,9.9,5.585,1.415,1.415,0,0,0,11.318,4.17Z",
    transform: "translate(-1.127 0.64)",
    fill: "#387F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCareers);
export default __webpack_public_path__ + "static/media/sidebar-careers.5ad047f39db95dc426773c508c99f091.svg";
export { ForwardRef as ReactComponent };